routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.login', {
      url: __env.routes.login,
      template: `<login sh-ctrl="shCtrl"></login>`
    })
    .state('home.revoveryPassword', {
        url: __env.routes.login,
        template: `<login r-pass="true" sh-ctrl="shCtrl"></login>`
      });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/login/login.config.js